import { Checkbox } from "@/components/ui/checkbox";
import type { HeaderContext } from "@tanstack/react-table";

export const SelectHeader = ({ table }: HeaderContext<any, unknown>) => {
  return (
    <Checkbox
      checked={
        table.getIsAllRowsSelected() ||
        (table.getIsSomeRowsSelected() && "indeterminate")
      }
      onCheckedChange={(value) => table.toggleAllRowsSelected(!!value)}
      aria-label="Select all"
    />
  );
};
